export default __webpack_public_path__ + "static/media/onboardingMobile.b049c0fd.png";